import {Vector2} from "./Vector2";
import {clamp} from "./math";


export class Rect {
    _minX: number
    _minY: number
    _sizeX: number
    _sizeY: number

    constructor(minX: number, minY: number, sizeX: number, sizeY: number) {

        this._minX = minX;
        this._minY = minY;
        this._sizeX = sizeX;
        this._sizeY = sizeY;
    }

    contains(point: Vector2) {

        return point.x > this.minX && point.y > this.minY && point.x < this.maxX && point.y < this.maxY
    }

    clamp(point: Vector2) {

        return new Vector2(
            clamp(point.x, this.minX, this.maxX),
            clamp(point.y, this.minY, this.maxY)
        )
    }

    get minX() {
        return this._minX;
    }

    get minY() {
        return this._minY;
    }

    get maxX() {
        return this._minX + this._sizeX;
    }

    get maxY() {
        return this._minY + this._sizeY;
    }
}